export default __webpack_public_path__ + "50dbb083ad28a131090b8ed562d7a56e.svg";